import axios from "axios";

let location = window.location.origin;
const API = `${location}/api/resendAccessCode`;

export default {
    post(data) {
        return axios.post(API, data);
    },
};
